//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAE.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[[],"GetDataContainer",{R_:{propertyList:"CAE.CaeDataContainer"}},0,0],[["solverName","propertyList"],"ImportSimulation",{R_:{newCaePart:"CAE.CaePart"}},2,0],[["contextPart"],"SetFileNewContext",{},1,0],[[],"NewCaeCoreService",{R_:{coreService:"CAE.CAECoreService"}},0,0],[["id"],"RemovePartCreatedHandler",{},1,0]],[["MaterialUtils","MaterialUtilities",0],["AssociationUtils","CAE.AssociationUtilities",0],["QualityAuditManager","CAE.QualityAudit.Manager",0],["UniversalConnectionUtilities","CAE.Connections.Utils",0],["MeshMappingUtils","CAE.MeshMapping.Utils",0],["PenetrationCheckManager","CAE.PenetrationCheck.Manager",0],["ModelDependencyCheckManager","CAE.ModelDependencyCheck.Manager",0],["JoinDataUtilities","CAE.Connections.JoinDataUtils",0],["ContactPreviewObjectCollection","CAE.ContactPreview.ContactObjectCollection",0],["MagnetUtils","CAE.Magnet.Utils",0]]];
SPLM.CAE.CaeSession = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CAE.CaeSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;